module.exports = __webpack_public_path__ + "assets/img/delta_logo_rgb_2026_W.5fcf0adb.png";